import axios from "axios";

const getBaseURL = () => {
  if (process.env.REACT_APP_BACKEND_URL && window.location.hostname.includes('preview.emergentagent.com')) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }
  return `${window.location.origin}/api`;
};

const api = axios.create({
  baseURL: getBaseURL(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("admin");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
